<template>
	<div class="mobile-hide shadow-1" color="white">
		<div class="row q-py-md q-px-md fit justify-center">
			<div class="col-sm-12">
				<div class="row">
					<div class="col-2">
						<img :src="logo" style="max-width: 100%; max-height: 50px;" height="auto" />
					</div>

					<div class="col-10 text-right self-center">
						<q-btn
							flat
							dense
							size="lg"
							:color="'admin_overview' === $route.name ? 'primary' : 'secondary'"
							:label="$t('overview')"
							@click="$router.push({ name: 'admin_overview' })"
						/>

						<q-btn-dropdown
							flat
							dense
							size="lg"
							:label="$t('records')"
							:color="getColorRegistrations()"
							v-if="showUsers || showOrganization || showTags || showImport"
						>
							<q-list link>
								<q-list-header v-if="showUsers">{{ $t('users') }}</q-list-header>

								<q-item
									v-for="(content, index) in users"
									:key="'ru' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showUsers"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showOrganization" />

								<q-list-header v-if="showOrganization">{{
									$t('organization')
								}}</q-list-header>

								<q-item
									v-for="(content, index) in organization"
									:key="'ro' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showOrganization"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showTags" />

								<q-list-header v-if="showTags">{{ $t('tags') }}</q-list-header>

								<q-item
									v-for="(content, index) in tags"
									:key="'tt' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showTags"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showImport" />

								<q-list-header v-if="showImport">{{ $t('import') }}</q-list-header>

								<q-item
									v-for="(content, index) in importUser"
									:key="'imp' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showImport"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown
							flat
							dense
							size="lg"
							:label="$t('communications')"
							:color="getColorComunications()"
							v-if="
								showSurveys ||
									showMessages ||
									showFaq ||
									showBanners ||
									showCalendar
							"
						>
							<q-list link>
								<q-list-header v-if="showSurveys">{{
									$t('surveys')
								}}</q-list-header>

								<q-item
									v-for="(content, index) in surveys"
									:key="'cs' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showSurveys"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showMessages" />

								<q-list-header v-if="showMessages">{{
									$t('messages')
								}}</q-list-header>

								<q-item
									v-for="(content, index) in messages"
									:key="'cm' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showMessages"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showFaq" />

								<q-list-header v-if="showFaq">{{ $t('faq') }}</q-list-header>

								<q-item
									v-for="(content, index) in faq"
									:key="'cf' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showFaq"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showBanners" />

								<q-list-header v-if="showBanners">{{
									$t('banners')
								}}</q-list-header>

								<q-item
									v-for="(content, index) in banners"
									:key="'cb' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showBanners"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showBanners" />

								<q-list-header v-if="showCalendar">{{
									$t('calendar')
								}}</q-list-header>

								<q-item
									v-for="(content, index) in calendar"
									:key="'cc' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showCalendar"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown
							flat
							dense
							size="lg"
							:label="$t('rewards')"
							:color="getColorRewards()"
							v-if="showRewards || showTablePoints"
						>
							<q-list link>
								<q-list-header>{{ $t('rewards') }}</q-list-header>

								<q-item
									v-for="(content, index) in rewards"
									:key="'rr' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta)"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showTablePoints" />

								<q-list-header v-if="showTablePoints">{{
									$t('points_table')
								}}</q-list-header>

								<q-item
									v-for="(content, index) in points_table"
									:key="'tablep' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showTablePoints"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown
							flat
							dense
							size="lg"
							icon="fal fa-cog"
							:color="getColorConfigurations()"
							v-if="is_superuser"
						>
							<q-list link>
								<q-list-header>{{ $t('configuration') }}</q-list-header>

								<q-item
									v-for="(content, index) in configurations"
									:key="'cas' + index"
									:to="{ name: content.to }"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'admin'] },

	data() {
		return {
			system_config: [
				{
					icon: 'far fa-list-ul',
					to: 'admin_config',
					text: 'configuration',
					meta: 'configuration',
				},
				{
					icon: 'far fa-clipboard-list-check',
					to: 'admin_terms',
					text: 'terms_and_conditions',
					meta: 'terms',
				},
				{
					icon: 'far fa-chalkboard',
					to: 'admin_about',
					text: 'about_the_company',
					meta: 'about',
				},
				{
					icon: 'far fa-user-secret',
					to: 'admin_policy',
					text: 'privacy_policy',
					meta: 'policy',
				},
				{
					icon: 'far fa-award',
					to: 'admin_badges',
					text: 'badges',
					meta: 'badges',
				},
				{
					icon: 'far fa-home',
					to: 'admin_home',
					text: 'home',
					meta: 'home',
				},
				{
					icon: 'far fa-cloud-upload',
					to: 'admin_imports',
					text: 'import',
					meta: 'admin_import',
				},
			],
			logo: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
			user_module_items: 'common/user_module_items',
			is_superuser: 'common/is_superuser',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		clientParams() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) return obj
			}
			return null
		},

		users() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-user',
							to: 'admin_users',
							text: 'users',
							meta: 'users',
						},
						{
							icon: 'far fa-users',
							to: 'admin_users_groups',
							text: 'users_groups',
							meta: 'users_groups',
						}
					)
				}
			}
			return contents
		},

		showUsers() {
			let show = false

			this.users.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		organization() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-city',
							to: 'admin_headquarters',
							text: 'headquarters',
							meta: 'headquarter',
						},
						{
							icon: 'far fa-building',
							to: 'admin_branches',
							text: 'branches',
							meta: 'branch',
						}
					)
				}
			}
			return contents
		},

		showOrganization() {
			let show = false

			this.organization.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		tags() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-hashtag',
						to: 'admin_tags',
						text: 'tags',
						meta: 'tags',
					})
				}
			}
			return contents
		},

		showTags() {
			let show = false

			this.tags.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		online() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-graduation-cap',
						to: 'admin_trainings',
						text: obj.title_trainings == '' ? 'courses' : obj.title_trainings,
						meta: 'trainings',
					})
				}
			}
			return contents
		},

		organization() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-city',
							to: 'admin_headquarters',
							text: 'headquarters',
							meta: 'headquarter',
						},
						{
							icon: 'far fa-building',
							to: 'admin_branches',
							text: 'branches',
							meta: 'branch',
						}
					)
				}
			}
			return contents
		},

		showOrganization() {
			let show = false

			this.organization.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		tags() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-hashtag',
						to: 'admin_tags',
						text: 'tags',
						meta: 'tags',
					})
				}
			}
			return contents
		},

		showTags() {
			let show = false

			this.tags.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		rewards() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-bullhorn',
							to: 'campaigns',
							text: 'campaigns',
							meta: 'reward_campaigns',
						},
						{
							icon: 'far fa-user-chart',
							to: 'users_reward_levels',
							text: 'users_on_campaign',
							meta: 'users_reward_levels',
						},
						{
							icon: 'far fa-tags',
							to: 'reward_categories',
							text: 'reward_categories',
							meta: 'reward_categories',
						},
						{
							icon: 'far fa-ticket-alt',
							to: 'rewards',
							text: 'rewards',
							meta: 'rewards',
						},
						{
							icon: 'far fa-list',
							to: 'reward_orders',
							text: 'reward_orders',
							meta: 'reward_orders',
						},
						{
							icon: 'far fa-calendar-alt',
							to: 'events',
							text: 'events',
							meta: 'events_qrcode',
						}
					)
				}
			}
			return contents
		},

		showRewards() {
			if (this.clientParams && this.clientParams.has_rewards) {
				let show = false

				this.rewards.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		points_table() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-trophy',
							to: 'reward_sale_products',
							text: 'intel_product',
							meta: 'reward_sale_products',
						},
						{
							icon: 'far fa-tag',
							to: 'reward_brands',
							text: 'brands',
							meta: 'reward_brands',
						},
						{
							icon: 'far fa-box',
							to: 'reward_sale_product_types',
							text: 'product_type',
							meta: 'reward_sale_product_types',
						},
						{
							icon: 'far fa-camera',
							to: 'photo_types',
							text: 'photo_types',
							meta: 'reward_upload_file_types',
						}
					)
				}
			}
			return contents
		},

		showTablePoints() {
			if (this.clientParams && this.clientParams.has_rewards) {
				let show = false

				this.points_table.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		campaigns() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-desktop',
						to: 'banners_campaign',
						text: 'banners_campaign',
						meta: 'banners_campaign',
					})
				}
			}
			return contents
		},

		showCampaigns() {
			if (this.clientParams && this.clientParams.has_rewards) {
				let show = false

				this.campaigns.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		surveys() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-poll-people',
						to: 'admin_surveys',
						text: 'surveys',
						meta: 'surveys',
					})
				}
			}
			return contents
		},

		showSurveys() {
			let show = false

			this.surveys.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		messages() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-comment',
						to: 'admin_messages',
						text: 'messages',
						meta: 'messages',
					})
				}
			}
			return contents
		},

		showMessages() {
			let show = false

			this.messages.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		faq() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-question-circle',
							to: 'admin_faqs',
							text: obj.title_faq === '' ? 'faq' : obj.title_faq,
							meta: 'faq',
						},
						{
							icon: 'far fa-list',
							to: 'admin_faq_categories',
							text: 'faq_categories',
							meta: 'faq_categories',
						}
					)
				}
			}
			return contents
		},

		showFaq() {
			let show = false
			let hasFaq = false

			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					hasFaq = obj.has_faq
				}
			}

			this.faq.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj && hasFaq) show = true
				}
			})
			return show
		},

		banners() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-sign',
							to: 'admin_banners',
							text: 'banners',
							meta: 'banners',
						},
						{
							icon: 'far fa-sign-in',
							to: 'banners_welcome',
							text: 'banners_welcome',
							meta: 'banners_welcome',
						}
					)
				}
			}
			return contents
		},

		showBanners() {
			let show = false

			this.banners.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		calendar() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-calendar-alt',
						to: 'schedules',
						text: 'calendar',
						meta: 'calendar',
					})
				}
			}
			return contents
		},

		showCalendar() {
			if (this.clientParams && this.clientParams.has_calendar) {
				let show = false

				this.calendar.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		importUser() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-cloud-upload',
						to: 'admin_imports',
						text: 'import',
						meta: 'admin_import',
					})
				}
			}
			return contents
		},

		showImport() {
			let show = false

			this.importUser.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		configurations() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-list-ul',
							to: 'admin_config',
							text: 'configuration',
							meta: 'configuration',
						},
						{
							icon: 'far fa-chalkboard',
							to: 'admin_about',
							text: 'about_the_company',
							meta: 'about',
						},
						{
							icon: 'far fa-clipboard-list-check',
							to: 'admin_terms',
							text: 'terms_and_conditions',
							meta: 'terms',
						},
						{
							icon: 'far fa-user-secret',
							to: 'admin_policy',
							text: 'privacy_policy',
							meta: 'policy',
						},
						{
							icon: 'far fa-award',
							to: 'admin_badges',
							text: 'badges',
							meta: 'badges',
						},
						{
							icon: 'far fa-home',
							to: 'admin_home',
							text: 'home',
							meta: 'home',
						},
						{
							icon: 'far fa-globe',
							to: 'area_config',
							text: 'areas',
							meta: 'area_config',
						},
						{
							icon: 'far fa-mailbox',
							to: 'mailing_list_config',
							text: 'mailing_list',
							meta: 'mailing_list',
						}
					)
				}
			}
			return contents
		},
	},

	methods: {
		showMenu(meta) {
			let obj = this.user_module_items.find((obj) => obj.slug === meta)
			return obj ? obj.permission : false
		},

		changeLogo() {
			let client = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			if (client) this.logo = client.logo
		},

		getColorRegistrations() {
			let meta_array = [
				'users',
				'users_groups',
				'headquarter',
				'branch',
				'tags',
				'reward_sale_products',
				'reward_brands',
				'reward_sale_product_types',
				'reward_upload_file_types',
			]

			let item = meta_array.find((obj) => obj === this.$route.meta.title)
			return item ? 'primary' : 'secondary'
		},

		getColorRewards() {
			let meta_array = [
				'reward_campaigns',
				'users_reward_levels',
				'reward_categories',
				'rewards',
				'reward_orders',
			]

			let item = meta_array.find((obj) => obj === this.$route.meta.title)
			return item ? 'primary' : 'secondary'
		},

		getColorComunications() {
			let meta_array = [
				'surveys',
				'messages',
				'faq',
				'faq_categories',
				'banners',
				'banners_welcome',
				'calendar',
			]

			let item = meta_array.find((obj) => obj === this.$route.meta.title)
			return item ? 'primary' : 'secondary'
		},

		getColorConfigurations() {
			let meta_array = [
				'configuration',
				'terms',
				'about',
				'policy',
				'badges',
				'users_import',
				'headquarter_import',
				'area_config',
				'mailing_list',
			]

			let item = meta_array.find((obj) => obj === this.$route.meta.title)
			return item ? 'primary' : 'secondary'
		},
	},

	watch: {
		params_loaded: function() {
			this.changeLogo()
		},

		id_user_client_selected: function() {
			this.changeLogo()
		},
	},

	mounted() {
		if (this.clients) {
			this.changeLogo()
		}
	},
}
</script>

<style></style>
